// extracted by mini-css-extract-plugin
module.exports = {"SectionH":"SectionH_SectionH__S_kfA"};